import React, {useEffect} from 'react';
import {useDispatch} from "react-redux";
import {setAnimating, setAnswer, setGenerating} from '../store/reducers/questionReducer';

interface IProps {
    chatAnswer: any;
    initialDelay: number;
    wordDelay: number;
    classNameBeforeDelay: string;
    classNameAfterDelay: string;
    identifier: string
}

function ChatAnimationSplit(props: IProps) {
    const {
        chatAnswer,
        initialDelay = 0,
        wordDelay = 0.2,
        classNameBeforeDelay,
        classNameAfterDelay,
        identifier
    } = props;
    const bottomRef = React.createRef<HTMLDivElement>();
    const dispatch = useDispatch();
    const [displayText, setDisplayText] = React.useState('');
    const [chatClassName, setChatClassName] = React.useState(classNameBeforeDelay);
    const [counter, setCounter] = React.useState<number>(0);

    function isElementInViewport() {
        let el = document.getElementById('m-chat-scroll-helper-id-main');
        if (el) {
            let rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= ((window.innerHeight || document.documentElement.clientHeight) - 100) && /* or $(window).height() */
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
            );
        } else {
            return null;
        }
    }

    React.useEffect(() => {
        const splitText = chatAnswer.split(' ');
        const timer = setTimeout(() => {
            if (splitText.length > 0) {
                setCounter(1);
            }
            setChatClassName(classNameAfterDelay)

        }, initialDelay * 1000);

        return () => clearTimeout(timer);
    }, [chatAnswer, initialDelay, wordDelay, classNameAfterDelay]);

    useEffect(() => {
        dispatch(setAnimating(identifier));
    }, []);
    React.useEffect(() => {
        const splitText = chatAnswer.split(' ');
        if (splitText.length > 0) {
            setTimeout(() => {
                if (counter < splitText.length) {
                    if (counter % 8 === 0 && isElementInViewport() === false) {
                        const chatEnd = (document as any).getElementById("m-chat-scroll-helper-id-chat");
                        chatEnd.scrollIntoView({behavior: "smooth"});
                        // const objDiv = (document as any).querySelector(".tc-main-container");
                        // (window as any).testdiv = objDiv;
                        // objDiv.scrollTop = objDiv.scrollHeight;
                        // bottomRef.current?.scrollIntoView({behavior: "smooth"})
                    }
                    setCounter(counter + 1);
                } else {
                    setTimeout(() => {
                        dispatch(setAnswer(''));
                        dispatch(setGenerating(''));
                    }, 1000)
                }
            }, wordDelay * 1000)
        }
    }, [counter])
    const splitText = chatAnswer.split(' ');
    const texttoanimate = splitText.slice(0, counter);

    return (
        <div className={chatClassName}>
            {texttoanimate.map((word: string, wordIndex: number) => {
                let words = (word && word.length > 0) ? word.replace(/\n/g, '<br/>') : word;
                return <span
                    key={wordIndex}
                    className={`${'fade-in-word'} ${classNameAfterDelay}`}
                    dangerouslySetInnerHTML={{__html: words + ' '}}
                >
                </span>
            })}
            <div id="m-chat-scroll-helper-id-main" className={`m-chat-scroll-helper`} ref={bottomRef}></div>
        </div>
    );
}

export default ChatAnimationSplit;

